let memCadastroTemp = null;
let memAtividadeEmCadastro = null;

function cloneSemImagemPesada(payload) {
  if (!payload || typeof payload !== "object") return payload;
  const copia = { ...payload };
  if (copia.imagem && copia.imagem.base64Data && copia.imagem.base64Data.length > 500000) {
    copia.imagem = {
      ...copia.imagem,
      base64Data: "",
    };
  }
  return copia;
}

export function setCadastroAtividadeTemp(payload) {
  memCadastroTemp = payload ? JSON.parse(JSON.stringify(payload)) : null;
  if (!payload) {
    sessionStorage.removeItem("cadastro-atividade-temp");
    return;
  }
  try {
    sessionStorage.setItem("cadastro-atividade-temp", JSON.stringify(payload));
  } catch (e) {
    try {
      sessionStorage.setItem(
        "cadastro-atividade-temp",
        JSON.stringify(cloneSemImagemPesada(payload))
      );
    } catch (_) {
      // Mantém exclusivamente em memória se sessionStorage estiver cheio
    }
  }
}

export function getCadastroAtividadeTemp() {
  if (memCadastroTemp) {
    return JSON.parse(JSON.stringify(memCadastroTemp));
  }
  const salvo = sessionStorage.getItem("cadastro-atividade-temp");
  if (!salvo) return null;
  try {
    return JSON.parse(salvo);
  } catch (e) {
    console.error("Erro ao ler cadastro-atividade-temp:", e);
    return null;
  }
}

export function clearCadastroAtividadeTemp() {
  memCadastroTemp = null;
  sessionStorage.removeItem("cadastro-atividade-temp");
}

export function setAtividadeEmCadastro(payload) {
  memAtividadeEmCadastro = payload ? JSON.parse(JSON.stringify(payload)) : null;
  if (!payload) {
    sessionStorage.removeItem("atividade-em-cadastro");
    return;
  }
  try {
    sessionStorage.setItem("atividade-em-cadastro", JSON.stringify(payload));
  } catch (e) {
    try {
      sessionStorage.setItem(
        "atividade-em-cadastro",
        JSON.stringify(cloneSemImagemPesada(payload))
      );
    } catch (_) {
      // Mantém exclusivamente em memória se sessionStorage estiver cheio
    }
  }
}

export function getAtividadeEmCadastro() {
  if (memAtividadeEmCadastro) {
    return JSON.parse(JSON.stringify(memAtividadeEmCadastro));
  }
  const salvo = sessionStorage.getItem("atividade-em-cadastro");
  if (!salvo) return null;
  try {
    return JSON.parse(salvo);
  } catch (e) {
    console.error("Erro ao ler atividade-em-cadastro:", e);
    return null;
  }
}

export function clearAtividadeEmCadastro() {
  memAtividadeEmCadastro = null;
  sessionStorage.removeItem("atividade-em-cadastro");
}
